import { CSSProperties, useEffect, useState } from 'react';
import styled from 'styled-components';

const Divider = styled.hr<{ $right: boolean }>`
  width: 44px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  background-color: ${(props) => props.theme.colors.primary};
  border-radius: ${(props) => props.theme.borderRadius};

  margin-top: 16px;
  margin-bottom: 16px;

  margin-left: ${(props) => (props.$right ? 'auto' : '2px')};
  margin-right: ${(props) => (props.$right ? '2px' : 'auto')};
`;

const Heading = styled.h2<{ $right: boolean }>`
  ${(props) => props.theme.font.h2};
  color: ${(props) => props.theme.colors.secondary};

  text-align: ${(props) => (props.$right ? 'right' : 'left')};
`;

const TextContent = styled.p<{ $right: boolean }>`
  ${(props) => props.theme.font.p1};
  color: ${(props) => props.theme.colors.secondary};
  white-space: pre-wrap;

  text-align: ${(props) => (props.$right ? 'right' : 'left')};
`;

type Props = {
  title: string;
  content?: string;
  right?: boolean;
  titleStyle?: CSSProperties;
};

const TextSection = ({
  title,
  content,
  right,
  titleStyle,
}: Props): JSX.Element => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <div>
      <Heading as="h2" $right={!!right} style={titleStyle}>
        {title}
      </Heading>
      <Divider $right={!!right} />
      {content &&
        (isMounted ? (
          <TextContent
            key={content.substring(0, 10) + new Date().getTime()}
            as="p"
            $right={!!right}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <TextContent as="p" $right={!!right}>
            {content}
          </TextContent>
        ))}
    </div>
  );
};

export default TextSection;
